import { Injectable } from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private _matSnackBar: MatSnackBar) { }

    notify(msg: string): void {
        // console.log('Pase por aca');
        this._matSnackBar.open(msg, 'OK', {
            verticalPosition: 'top',
            horizontalPosition: 'left',
            duration        : 60000
        });
    }
}
